// extracted by mini-css-extract-plugin
module.exports = {"root":"banner-action_root__j0XMg"};